import { WHATSAPP_NUMBER } from '../../../constants/homeData';
import knowledgeHeroBg from '../../../assets/images/rocketbanner.png';
import RocketIllustration from './RocketIllustration';
import { Link } from 'react-router-dom';

function KnowledgeHeroSection() {
  return (
    <section className="px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="relative">
          {/* Gradient border + drop shadow wrapper (Figma) */}
          <div className="rounded-[20px] p-[2px] ">
            {/* Inner card */}
            <div className="relative overflow-hidden rounded-[18px] ">
              {/* Background image + light wash */}
              <div
                className="absolute inset-0 bg-no-repeat"
                style={{
                  backgroundImage: `url(${knowledgeHeroBg})`,
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'top center',
                }}
                aria-hidden
              />

              <div className="relative flex flex-col lg:min-h-[420px] lg:flex-row lg:items-start xl:min-h-[480px]">
                {/* Left: rocket overlaps edge */}
                <div className="relative z-10 flex shrink-0 justify-center px-4 pt-6 lg:w-[27%] lg:justify-end lg:px-0 lg:pt-0">
                  <div className="relative -mb-8 lg:-ml-6 lg:-mb-0 lg:mt-[-14px] xl:-ml-10 xl:mt-[-10px]">
                    <RocketIllustration />
                  </div>
                </div>

                {/* Right: content */}
                <div className="flex flex-1 flex-col justify-center px-6 pb-8 pt-2 lg:px-10 lg:pb-10 lg:pt-12 lg:pr-12">
                  <h2 className="pt-6 text-2xl font-bold leading-tight text-[#1b1b1b] sm:pt-8 sm:text-[28px] lg:pt-10 lg:text-[32px] xl:text-[36px] lg:leading-snug">
                    Knowledge is the fuel, learning is the spark
                  </h2>
                  <p className="mt-2 text-base font-semibold text-[#9369CC] sm:text-lg">
                    Start your learning, and let success chase you.
                  </p>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-[#666666] sm:text-[16px]">
                    CHSE Express brings structured study materials, expert guidance, and smart revision
                    tools so Class 11 &amp; 12 students can learn at their own pace — anytime, anywhere.
                  </p>

                  <div className="mt-6 flex flex-wrap items-center gap-10">
                    <Link
                      to="/courses/free"
                      className="rounded-full bg-[#9369CC] px-7 py-2.5 text-base font-semibold text-white shadow-md transition"
                    >
                      Explore Free Courses
                    </Link>
                    <a
                      href={`https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2.5 text-base font-medium text-[#1b1b1b]"
                    >
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#25D366] text-white">
                        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.75.75 0 00.918.918l4.458-1.495A11.953 11.953 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.714 9.714 0 01-4.875-1.302l-.349-.207-3.228 1.082 1.082-3.228-.207-.349A9.714 9.714 0 013.75 12c0-4.556 3.694-8.25 8.25-8.25s8.25 3.694 8.25 8.25-3.694 8.25-8.25 8.25z" />
                        </svg>
                      </span>
                      {WHATSAPP_NUMBER}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default KnowledgeHeroSection;
